export default __webpack_public_path__ + "static/media/warning--stop-ahead--g4.5c3b7c40.png";